import { render, staticRenderFns } from "./PersonnelLeaveList.vue?vue&type=template&id=b6a67086"
import script from "./PersonnelLeaveList.vue?vue&type=script&lang=js"
export * from "./PersonnelLeaveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports